<template>
  <div
    class="dropdown"
    :class="{ show: isOpen }"
    v-bind="passthroughAttrs"
    v-on-click-outside="close"
  >
    <button
      type="button"
      class="btn dropdown-toggle"
      :class="buttonClasses"
      :aria-expanded="isOpen ? 'true' : 'false'"
      @click="toggle"
    >
      <slot name="button-content">{{ text }}</slot>
    </button>
    <div class="dropdown-menu" :class="{ show: isOpen }">
      <slot />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdDropdown',

  inheritAttrs: false,

  props: {
    text: {
      type: String,
      default: 'Dropdown'
    },
    variant: {
      type: String,
      default: 'secondary'
    }
  },

  emits: [],

  data() {
    return {
      isOpen: false
    };
  },

  computed: {
    buttonClasses() {
      return [`btn-${this.variant}`];
    },

    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    }
  },

  directives: {
    'on-click-outside': {
      bind(el, binding) {
        el.__clickOutsideHandler__ = (event) => {
          if (!el.contains(event.target)) binding.value(event);
        };

        document.addEventListener('click', el.__clickOutsideHandler__);
      },

      unbind(el) {
        document.removeEventListener('click', el.__clickOutsideHandler__);
        delete el.__clickOutsideHandler__;
      }
    }
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },

    close() {
      this.isOpen = false;
    },

    hide() {
      this.close();
    }
  }
});
</script>
